module.exports = __webpack_public_path__ + "img/408.96279e34.png";